import {computed, inject, Injectable} from '@angular/core';
import {UserProfileStore} from './auth/stores/user-profile.store';
import {MailboxConfiguratorStore} from '../features/mailbox-configurator/mailbox-configurator.store';
import {DashboardContext} from '../features/dashboard/dashboard-context';

@Injectable({ providedIn: 'root' })
export class AppContext {
	private profileStore = inject(UserProfileStore)
	private mailboxesStore = inject(MailboxConfiguratorStore)
	private dashboardCtx = inject(DashboardContext)

	readonly user = this.profileStore.currentUser
	readonly chosenMailbox = this.profileStore.currentMailbox

	mailboxForApp = computed(() => {
		const chosenId = this.chosenMailbox()?.mailbox_id;
		const loaded = this.mailboxesStore.loadedMailbox();

		if (!chosenId || !loaded) return null;

		if (loaded.id !== chosenId) return null;

		return loaded;
	});

	appMode = computed(() => {
		if (!this.user()) return 'anonymous';

		const chosenMailbox = this.chosenMailbox();
		if (!chosenMailbox) return 'no-selection';

		const mailbox = this.mailboxForApp();

		if (!mailbox || this.mailboxesStore.loading()) return 'loading';

		const hasConfig =
			mailbox.inbound_configuration || mailbox.outbound_configuration;

		if (!hasConfig) {
			return this.dashboardCtx.initialLoadComplete()
				? 'onboarding'
				: 'loading';
		}

		return 'ready';
	})
}
